export function CalendarAbsence(currentYear, currentMonth, absence) {
  const firstDayOfMonth = new Date(currentYear, currentMonth, 1);
  const lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0);
  const daysInMonth = lastDayOfMonth.getDate();
  const startDay = (firstDayOfMonth.getDay() + 6) % 7;

  const weeks = [];
  let week = [];

  for (let i = 0; i < startDay; i++) {
    week.push({ day: "", date: null, hasAbsence: false, absenceStatus: 'none' });
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(currentYear, currentMonth, day);
    // Usar getFullYear/getMonth/getDate para evitar problemas de zona horaria con toISOString
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const dayStr = String(date.getDate()).padStart(2, '0');
    const dateStr = `${year}-${month}-${dayStr}`;

    // Obtener todas las ausencias que coinciden con esta fecha
    const absencesOnDate = absence.filter((abs: any) => {
      // Usar fechas locales para evitar problemas de timezone
      const startDate = new Date(abs.start);
      const endDate = new Date(abs.end);

      // Extraer solo año, mes y día sin considerar horas
      const startYear = startDate.getFullYear();
      const startMonth = startDate.getMonth();
      const startDay = startDate.getDate();

      const endYear = endDate.getFullYear();
      const endMonth = endDate.getMonth();
      const endDay = endDate.getDate();

      // Comparar usando solo año, mes y día del calendario actual
      const isAfterOrEqualStart =
        currentYear > startYear ||
        (currentYear === startYear && currentMonth > startMonth) ||
        (currentYear === startYear && currentMonth === startMonth && day >= startDay);

      const isBeforeOrEqualEnd =
        currentYear < endYear ||
        (currentYear === endYear && currentMonth < endMonth) ||
        (currentYear === endYear && currentMonth === endMonth && day <= endDay);

      return isAfterOrEqualStart && isBeforeOrEqualEnd;
    });

    // Determinar el estado de las ausencias en este día
    let absenceStatus = 'none';
    let isBaja = false;
    if (absencesOnDate.length > 0) {
      const hasApproved = absencesOnDate.some((abs: any) => abs.status === 'approved');
      const hasPending = absencesOnDate.some((abs: any) => abs.status === 'pending');
      isBaja = absencesOnDate.some((abs: any) => abs.tipoAusencia && abs.tipoAusencia.startsWith('Baja:'));

      if (isBaja) {
        absenceStatus = hasApproved ? 'baja-approved' : 'baja-pending';
      } else if (hasApproved && hasPending) {
        absenceStatus = 'mixed';
      } else if (hasApproved) {
        absenceStatus = 'approved';
      } else if (hasPending) {
        absenceStatus = 'pending';
      }
    }

    const hasAbsence = absencesOnDate.length > 0;

    week.push({
      day,
      date: dateStr,
      hasAbsence,
      absenceStatus,
      isBaja
    });

    if (week.length === 7) {
      weeks.push(week);
      week = [];
    }
  }

  if (week.length > 0) {
    while (week.length < 7) {
      week.push({ day: "", date: null, hasAbsence: false, absenceStatus: 'none' });
    }
    weeks.push(week);
  }

  return weeks;
}
